import { useAPPstore } from '@/service/stores/cm/cmcm/APP.store'
import { gfnSysDate } from '@/utils/helper/date.helper'

const BG_EXEC_CYCLE = 3 * 60 * 1000 // 3분

let positTrnsInterval = null
let APPstore = null
let mbrJoinCd = null
let beginTime = null
let endTime = null
let isDoingTrns = false

export const startPositTrnsSvc = async (options) => {
  APPstore = useAPPstore()

  mbrJoinCd = options.joinCd
  beginTime = options.beginTime
  endTime = options.endTime

  await $nvBridge.location.prepare()

  positTrnsInterval = setInterval(doPositTrns, BG_EXEC_CYCLE)
  doPositTrns()
}

export const stopPositTrnsSvc = async () => {
  await $nvBridge.location.stop()

  clearInterval(positTrnsInterval)
  mbrJoinCd = null
}

export const doPositTrns = async () => {
  if (isDoingTrns) {
    return
  }
  isDoingTrns = true

  try {
    const curTime = Number(gfnSysDate('HHmmss'))
    if (curTime < beginTime || curTime > endTime) {
      return
    }

    const crntPosit = await getCrntPosit()
    await APPstore.actionHttpSuppMoDlCmmDlvyCommUpdateDlvyPosit({
      ...crntPosit,
      joinCd: mbrJoinCd
    })
  } finally {
    isDoingTrns = false
  }
}

const getCrntPosit = async () => {
  const locationResult = await $nvBridge.location.get()
  const rtVal = {
    mapX: '37.5203165',
    mapY: '127.1133907',
    addr: '대한민국 서울특별시 송파구'
  }

  if (locationResult) {
    rtVal.mapX = locationResult.latitude
    rtVal.mapY = locationResult.longitude
    rtVal.addr = await getAddr(locationResult.longitude, locationResult.latitude)
  }

  return rtVal
}

const getAddr = (long, lat) => {
  const geocoder = new window.kakao.maps.services.Geocoder()

  return new Promise((resolve) => {
    geocoder.coord2RegionCode(long, lat, (result, status) => {
      let addr
      if (status === window.kakao.maps.services.Status.OK) {
        for (let i = 0; i < result.length; i++) {
          // 행정동의 region_type 값은 'H'이므로
          if (result[i].region_type === 'H') {
            addr = result[i].address_name
            break
          }
        }
      }
      resolve(addr)
    })
  })
}
